<template>
  <div class="app-footer__certificates">
    <div>
      <img
          class="app-footer__certificates--co2"
          :src="zertifikatCO2" alt="zertifikatCO2"
      >
    </div>
    <div>
      <img
          class="app-footer__certificates--regionalversorger"
          :src="regionalVersorger" alt="Deutschlands beste Regionalversorger 2024 - Herausragend Strom und Gas"
      >
    </div>
  </div>
</template>

<script setup lang="ts">
const zertifikatCO2 = `${window.ioappConfig.themeUri}/public/img/Zertifikat-co2neutralwebsite.svg`;
const regionalVersorger = `${window.ioappConfig.themeUri}/public/img/DeutschlandsbesteRegionalversorger2024HerausragendStromundGas.png`;
</script>

<style scoped lang="scss">
@import "src/scss/component-helpers";

.app-footer__certificates {
  display: grid;
  width: 100%;
  grid-template-rows: auto;
  grid-template-columns: auto;
  align-items: start;
  justify-content: center;

  @media ((min-width: map_get($grid-breakpoints, 'sm')) and (max-width: #{map_get($grid-breakpoints, 'lg') - 1px})) {
    gap: 1.875rem;
  }

  @media (min-width: map_get($grid-breakpoints, 'sm')) {
    grid-template-columns: auto;
    justify-content: space-between;
  }

  @media (min-width: map_get($grid-breakpoints, 'lg')) {
    grid-template-columns: auto auto;
  }

  @media (min-width: map_get($grid-breakpoints, 'lg')) and (max-width: #{map_get($grid-breakpoints, 'xxl') - 1px}) {
    gap: 1.875rem;
    justify-content: center;
  }

  @media (min-width: map_get($grid-breakpoints, 'xxl')) {
    display: inline-grid;
    width: auto;
    gap: .875rem;
  }

  @media (min-width: 1680px) {
    gap: 1.875rem;
  }

  img {
    display: block;
    width: auto;
  }

  > div {
    &:first-child {
      grid-column: 1 / 2;

      @media
      ((min-width: map_get($grid-breakpoints, 'sm')) and (max-width: #{map_get($grid-breakpoints, 'lg') - 1px})),
      ((min-width: map_get($grid-breakpoints, 'xxl')) and (max-width: 1679px)) {
        grid-column: 1 / 3;
        grid-row: 1 / 2;
      }

      @media (min-width: map_get($grid-breakpoints, 'lg')) and (max-width: #{map_get($grid-breakpoints, 'xxl') - 1px}) {
        grid-column: 1 / 2;
      }
    }

    &:nth-child(2) {
      grid-column: 1 / 2;

      @media
      ((min-width: map_get($grid-breakpoints, 'sm')) and (max-width: #{map_get($grid-breakpoints, 'lg') - 1px})),
      ((min-width: map_get($grid-breakpoints, 'xxl')) and (max-width: 1679px)) {
        grid-column: 1 / 3;
        grid-row: 2 / 3;
      }

      @media (min-width: map_get($grid-breakpoints, 'lg')) and (max-width: #{map_get($grid-breakpoints, 'xxl') - 1px}) {
        grid-column: 2 / 3;
        grid-row: 1 / 2;
      }

      @media (min-width: 1680px) {
        grid-column: 2 / 3;
        grid-row: 1 / 2;
      }
    }
  }

  &--co2 {
    height: 2.1875rem;
    max-width: 100%;
    width: auto;

    @media (max-width: map_get($grid-breakpoints, 'sm')) {
      height: 3.125rem;
      margin: 0 auto 1rem auto;
    }

    @media (min-width: map_get($grid-breakpoints, 'md')) {
      height: 4.75rem;
    }
  }

  &--regionalversorger {
    height: 6.125rem;
    max-width: 100%;
    width: auto;

    @media (min-width: map_get($grid-breakpoints, 'sm')) {
      margin: 0 auto 1rem auto;
    }

    @media (min-width: map_get($grid-breakpoints, 'md')) {
      height: 9.75rem;
    }
  }
}
</style>
